import React, { Fragment } from "react"
import { graphql } from "gatsby"
import heroRecruiters from "../assets/hero-recruiters.svg"
import Layout from "../components/layout"
import HowSection from "../components/how-section"
import BenefitsSection from "../components/benefits-section"
import PricingSection from "../components/pricing-section"
import HeroSectionRecruiter from "../components/hero-section-recruiter"
import FaqRecruitersSection from "../components/faq-recruiters-section"
import AboutRecruiterSection from "../components/about-recruiter-section"
import howTorecruiters1 from "../assets/howto-recruiters1.svg"
import howTorecruiters2 from "../assets/howto-recruiters2.svg"
import howTorecruiters3 from "../assets/howto-recruiters3.svg"
import benefit1 from "../assets/benefit-recruiters1.svg"
import benefit2 from "../assets/benefit-recruiters2.svg"
import benefit3 from "../assets/benefit-recruiters3.svg"
import benefit4 from "../assets/benefit-recruiters4.svg"
import benefit5 from "../assets/benefit-recruiters5.svg"
import benefit6 from "../assets/benefit-recruiters6.svg"
import { withPreview } from "gatsby-source-prismic"

export const query = graphql`
  query RecruitersQuery($uid: String, $lang: String) {
    prismicRecruiters(lang: { eq: $lang }, uid: { eq: $uid }) {
      data {
        title_pricing
        title_meta
        title_how
        title_hero
        title_faq
        title_benefits
        title_about
        subtitle_hero
        text_about
        plans_pricing {
          benefits_pricing {
            text
            raw
          }
          price
          subtitle_pricing
          title
        }
        keywords_meta
        items_how {
          howto_text {
            text
            raw
          }
          list {
            text
            raw
          }
          text
          title
        }
        items_faq {
          answer
          question
        }
        items_benefits {
          text
          title
        }
        image_meta {
          dimensions {
            height
            width
          }
          url
        }
        description_meta
        button_hero
        button_pricing
      }
    }
  }
`

const RenderBody = ({ hero, how, benefits, faq, pricing, about, locale }) => {
  return (
    <Fragment>
      <HeroSectionRecruiter
        hero={hero}
        href="https://recruiter.moberries.com/signup"
        heroImage={heroRecruiters}
        locale={locale}
      />
      <AboutRecruiterSection about={about} />
      <HowSection
        how={how}
        page="recruiters"
        howImgs={[howTorecruiters1, howTorecruiters2, howTorecruiters3]}
      />
      <BenefitsSection
        benefits={benefits}
        page="recruiters"
        itemClassName="col-md-6 col-lg-4 text-center d-flex flex-column"
        benefitImgs={[
          benefit1,
          benefit2,
          benefit3,
          benefit4,
          benefit5,
          benefit6,
        ]}
      />
      <PricingSection
        pricing={pricing}
        link="https://recruiter.moberries.com/signup"
      />
      <FaqRecruitersSection faq={faq} />
    </Fragment>
  )
}

const RecruitersTemplate = ({ data, pageContext, uri, location }) => {
  const { lang: locale } = pageContext
  const doc = data.prismicRecruiters.data

  if (!doc) return null
  const {
    title_hero,
    button_hero,
    subtitle_hero,
    title_how,
    items_how,
    title_benefits,
    items_benefits,
    title_pricing,
    button_pricing,
    plans_pricing,
    title_faq,
    items_faq,
    title_about,
    text_about,
    title_meta,
    description_meta,
    keywords_meta,
    image_meta,
  } = doc
  return (
    <Layout
      metadata={{
        title: title_meta,
        description: description_meta,
        keywords: keywords_meta,
        image: image_meta && image_meta.url,
      }}
      mainPage="recruiters"
      locale={locale}
      path={location && location.pathname}
    >
      <RenderBody
        how={{ title: title_how, items: items_how }}
        faq={{
          title: title_faq,
          items: items_faq,
        }}
        hero={{
          button: button_hero,
          subtitle: subtitle_hero,
          title: title_hero,
        }}
        benefits={{
          title: title_benefits,
          items: items_benefits,
        }}
        about={{
          title: title_about,
          text: text_about,
        }}
        pricing={{
          plans: plans_pricing,
          title: title_pricing,
          button: button_pricing,
        }}
        locale={locale}
      />
    </Layout>
  )
}

export default withPreview(RecruitersTemplate)
